import React from 'react';
import BubbleText from './BubbleText';
import { onHealthRowClick } from '../../faseMonitor/actions';
import PieChart from 'react-minimal-pie-chart';

const utils = require('@airfi-disco/shared/utils');

const { humanizePercentage } = utils;

interface HealthTableProps {
  ok?: number;
  halting?: number;
  failing?: number;
  title?: React.ReactNode;
  filterHealth?: string | null;
  style?: React.CSSProperties;
}

function HealthTable({ ok = 0, halting = 0, failing = 0, title, filterHealth, style }: HealthTableProps) {
  const total = ok + halting + failing;

  const renderHealthRow = (healthKey: string, label: string, bubbleType: string, count: number) => {
    const isActive = filterHealth === healthKey;
    return (
      <div
        className={`fase-monitor__health-row ${isActive ? 'fase-monitor__health-row--active' : ''}`}
        onClick={() => onHealthRowClick(healthKey)}
      >
        <div className="fase-monitor__health-label">
          <BubbleText text={`${label}:`} bubbleType={bubbleType} />
        </div>
        <div className="fase-monitor__health-value">{humanizePercentage(count / total)}</div>
        <div className="fase-monitor__health-count">{count}</div>
      </div>
    );
  };

  return (
    <div className="fase-monitor__card fase-monitor__health-card" style={style}>
      <div className="fase-monitor__health-header">
        <div className="fase-monitor__health-title">{title}</div>
        <div className="fase-monitor__health-chart">
          {total > 0 ? (
            <PieChart
              startAngle={270}
              data={[
                { title: 'OK', value: ok, color: '#6FE20D' },
                { title: 'Not up-to-date', value: halting, color: '#FFE72C' },
                { title: 'Offline', value: failing, color: '#FF2C2C' },
              ].filter((segment) => segment.value > 0)}
            />
          ) : (
            <div className="fase-monitor__health-chart--empty" />
          )}
        </div>
      </div>

      {renderHealthRow('ok', 'OK', 'ok', ok)}
      {renderHealthRow('halting', 'Downloading OK', 'halting', halting)}
      {renderHealthRow('failing', 'Offline', 'failing', failing)}
      <div className="fase-monitor__health-row" onClick={() => onHealthRowClick('all')}>
        <div className="fase-monitor__health-label" style={{ paddingLeft: 18 }}>
          Total
        </div>
        <div className="fase-monitor__health-value" />
        <div className="fase-monitor__health-count">{total}</div>
      </div>
    </div>
  );
}

export default HealthTable;
